
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import common from '../redux/slice/common';
import propertySearch from '../redux/slice/property-search';

const reducers = combineReducers({
	common,
	propertySearch,
});

const persistConfig = {
	key: 'nicolRoot',
	storage,
	timeout: null,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
	reducer: persistedReducer,
});

export default store;
